import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import XEUtils from "xe-utils";
import httpManager from "../../util/common";

let vm={
    data(){
        return {
            loading:false,
            report_date:null,
            cur_date:null,
            date_list:[],
            date_list_data:[],
            data:[],
            gics:{},
            tableColumn:[
                {title:'行业',field:"gics_name",width:150},
                {title:'研报数',field:"reports",width:100},
                // {title:'热门词汇',field:"hot_words"},
                {title: "热门词汇", slots: {default: 'num_default'}},
            ],
        }
    },
    methods:{

        //日期搜索
        reportDateFilter(inputValue, path){
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        },
        // 获取gics二级行业分类
        async getGicsLevel2(){
            let self=this
            await httpManager('gics')
            .then((response)=>{
                for(let item of response.data.data){
                    self.gics[item.industry_group_code]=item.industry_group
                }
            })
            .catch((error)=>{
                console.log('error');
            })
        },
        // 获取本周行业热词
        getHotWordsData(){
            let self=this
            self.loading=true
            let params = new Map()
            if(self.report_date){
                params.set('report_date',self.report_date)
            }else{
                params.set('report_date',self.date_list[0])
            }
            httpManager("stock_report_industry",params,null,null,null)
            .then((response)=>{
                if(response.status==401||response.status==403){
                    self.data=[]
                    return ;
                }
                self.data=response.data.data
                for(let item of self.data){
                    item.gics_name=self.gics[item.gics]
                    item.hot_words_list=[]
                    // item.subject_headings_special.map((i)=>item.hot_words_list.push(i[0]))
                    item.subject_headings_special.map((i,index)=>{
                        let len=item.subject_headings_special.length
                        if(index!==len-1){
                            item.hot_words_list.push(i[0]+' , ')
                        }else{
                            item.hot_words_list.push(i[0])
                        }
                    })
                    item.hot_words=item.hot_words_list.join(' , ')
                }
                self.loading=false
            })
            .catch((error)=>{
                this.cur_date=[this.date_list[1]]
                self.report_date=self.date_list[1]
                try{
                    getHotWordsData()
                }catch(error){
                    self.loading=false
                }

            })
        },
        // 时间戳转换成日期
        timestampToTime(timestamp) {
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate() <10?'0'+date.getDate():date.getDate();
            return Y+M+D;
        },
        // 获取选择框的日期
        getDateList(){                        
            var res=[]
            var date=new Date('2021-01-03')
            var datems=date.getTime()
            // 获取本周日的日期
            var now=new Date()
            var cur_day=now.getDay()
            var nowms=now.getTime()
            var sundayms=nowms+(7-cur_day)*24*3600*1000
            if(cur_day==1){
                sundayms=nowms-24*3600*1000
            }
            while(datems<=sundayms){
                res.push(datems)
                datems+=7*24*3600*1000
            }
            this.date_list=res.map((item)=>this.timestampToTime(item)).reverse()
            this.date_list.map((item)=>{
                let obj={}
                obj.label=item
                obj.value=item
                this.date_list_data.push(obj)
            })
        },
        // 事件关联所处日期选项框
        dateListOnChange(value){
            this.report_date = value[value.length-1]
        },  



    },
    async mounted(){
        this.getDateList()
        this.cur_date=[this.date_list[0]]
        await this.getGicsLevel2()
        await this.getHotWordsData()
    },

    watch:{
        report_date:function(){
            this.getHotWordsData()
        },
    }
}

Vue.component("industry_hot_words", vm)
export default vm



// WEBPACK FOOTER //
// ./src/research_report/js/industry_hot_words.js